export const LOYALTY_AVAILABILITY = 'LOYALTY_AVAILABILITY';
export const LOYALTY_INFO = 'LOYALTY_INFO';
